import { Box, Button, Grid, Stack, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReferalHeaderPicture from "../../assets/referal_header.svg";
import OnePicture from "../../assets/one_ref.svg";
import TwoPicture from "../../assets/two_ref.svg";
import ThreePicture from "../../assets/three_ref.png";
import GetLinkPicture from "../../assets/get_link_ref.png";
import InvirePicture from "../../assets/invite_link_ref.svg";
import GetPricePicture from "../../assets/get_price_link_ref.svg";
import "./Referral.css";
import { useEffect } from "react";

export default function Referral() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = " دعوت دوستان ";
  }, []);
  const [t] = useTranslation();
  return (
    <Box sx={{ bgcolor: "background.default", py: 4 }}>
      <Container>
        <Grid container>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ justifyContent: "center", display: "flex" }}
          >
            <Stack spacing={3} justifyContent={"center"}>
              <Typography variant="h5" sx={{ color: "text.primary" }}>
                {t("invite_friends")}
              </Typography>
              <Typography variant="subtitle1" sx={{ color: "text.secondary" }}>
                .با دعوت دوستان خود در سود پارسیان بیت شریک شوید
              </Typography>
              <Button
                variant="contained"
                sx={{
                  width: "10rem",
                  height: "2.5rem",
                  px: 2,
                  py: 2.5,
                  borderRadius: "50px",
                  background: "#FF3DFF",
                  mt: { xs: 2, sm: 0 },
                }}
              >
                {t("ask_your_question")}
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <img
                src={ReferalHeaderPicture}
                alt="picture header referal"
                width="100%"
              />
            </Box>
          </Grid>
        </Grid>
        <Typography
          variant="h5"
          sx={{ color: "text.primary", textAlign: "center", mt: 4.5, mb: 1.5 }}
        >
          {t("how_invite_friends")}
        </Typography>
        <Grid container sx={{ py: 4, my: 1.5 }}>
          <Grid item xs={12} md={4}>
            <Stack alignItems={"center"} spacing={1.5} px={2} py={1.5}>
              <Box>
                <img src={GetLinkPicture} alt="invite friends" width="100%" />
              </Box>
              <Stack
                direction={"row"}
                spacing={0.75}
                alignItems={"center"}
                gap={"10px"}
              >
                <Box
                  bgcolor={"#FF3DFF"}
                  p={1}
                  fontSize={"20px"}
                  borderRadius={"5px"}
                >
                  1
                </Box>
                <Typography
                  variant="h6"
                  sx={{ color: "text.primary", textAlign: "center" }}
                >
                  {t("get_invite_link")}
                </Typography>
              </Stack>
              <Typography
                variant="subtitle2"
                sx={{ color: "text.secondary", textAlign: "center" }}
              >
                ابتدا در وبسایت ثبت نام کنید و لینک دعوت تان را دریافت کنید
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack alignItems={"center"} spacing={1.5} px={2} py={1.5}>
              <Box>
                <img src={InvirePicture} alt="invite friends" width="100%" />
              </Box>
              <Stack
                direction={"row"}
                spacing={0.75}
                alignItems={"center"}
                gap={"10px"}
              >
                <Box
                  bgcolor={"#FF3DFF"}
                  p={1}
                  fontSize={"20px"}
                  borderRadius={"5px"}
                >
                  2
                </Box>
                <Typography
                  variant="h6"
                  sx={{ color: "text.primary", textAlign: "center" }}
                >
                  {t("invite_friends_2")}
                </Typography>
              </Stack>
              <Typography
                variant="subtitle2"
                sx={{ color: "text.secondary", textAlign: "center" }}
              >
                لینک دعوت را برای دوستان خود ارسال کنید
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack alignItems={"center"} spacing={1.5} px={2} py={1.5}>
              <Box>
                <img src={GetPricePicture} alt="invite friends" width="100%" />
              </Box>
              <Stack
                direction={"row"}
                spacing={0.75}
                alignItems={"center"}
                gap={"10px"}
              >
                <Box
                  bgcolor={"#FF3DFF"}
                  p={1}
                  fontSize={"20px"}
                  borderRadius={"5px"}
                >
                  3
                </Box>
                <Typography
                  variant="h6"
                  sx={{ color: "text.primary", textAlign: "center" }}
                >
                  {t("get_price")}
                </Typography>
              </Stack>
              <Typography
                variant="subtitle2"
                sx={{ color: "text.secondary", textAlign: "center" }}
              >
                با ثبت نام دوستان شما در وبسایت و ثبت سفارش، در سود معاملات آنها
                شریک می شوید
              </Typography>
            </Stack>
          </Grid>
        </Grid>
        <Box
          sx={{
            bgcolor: "background.darkBlack",
            borderRadius: "10px",
            py: 4,
            px: 4,
          }}
        >
          <ul data-v-e8d0da8a="" className="px-24 pt-24 pb-16 ul_terms">
            <li data-v-e8d0da8a="" className="li_referral">
              در حال حاضر ۳۰٪ از کارمزد تمامی معاملات انجام شده توسط کاربر معرفی
              شده در بازارهای پارسیان بیت به فرد ارجاع دهنده تعلق می&zwnj;گیرد
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              برای هر معامله دقیقاً ۳۰٪ ارزش معادل ریالی کارمزد کسر شده از طرف
              دعوت شده به فرد ارجاع دهنده تعلق می&zwnj;گیرد. مبلغ کارمزد بر اساس
              درصد کارمزد کاربر دعوت شده و ارزش معادل ریالی کارمزد در لحظه انجام
              معامله با دقت یک ریال محاسبه می&zwnj;شود. در بازارهای تتر قیمت
              خرید لحظه&zwnj;ای استاندارد تتر در پارسیان بیت برای تعیین ارزش
              ریالی کارمزد لحاظ می&zwnj;شود.
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              در صورت ثبت نام یک کاربر با کد معرف کاربر دیگر، امکان حذف یا تغییر
              کد معرف وجود نخواهد داشت.
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              هدیه&zwnj;ی ارجاع به صورت تجمیعی پس از رسیدن مجموع مبالغ آن به حد
              نصاب ده هزار تومان به حساب کیف پول ریال معرف در پارسیان بیت واریز
              می&zwnj;شود. در صورت کمتر بودن مجموع مبالغ از این حد نصاب، مجموع
              مبالغ پس از گذشت هفت روز به حساب معرف واریز می&zwnj;شود.
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              ملاک ثبت رابطه&zwnj;ی دعوت، وجود کد دعوت در فرم ثبت&zwnj;نام یا
              استفاده از همان پیوند معرف برای ثبت&zwnj;نام است. در صورتی که به
              هر دلیل ثبت&zwnj;نام بدون کد یا پیوند معرف صورت بگیرد، مبلغی برای
              معرف در نظر گرفته نمی&zwnj;شود.
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              فرد معرفی شده می&zwnj;تواند حداکثر تا ۲۴ ساعت پس از زمان
              ثبت&zwnj;نام با ورود به سامانه کد معرف خود را ثبت نماید. مسئولیت
              اطمینان از ثبت معرف برای کاربران دعوت شده صرفاً بر عهده&zwnj;ی
              معرف بوده و پارسیان بیت مسئولیتی در قبال عدم ورود کد معرف توسط فرد
              معرفی شده ندارد.
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              محدودیتی در تعداد دوستان معرفی شده توسط یک معرف وجود ندارد
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              محاسبه&zwnj;ی درصد ارجاع دهنده در لحظه&zwnj;ی انجام هر معامله صورت
              می&zwnj;گیرد. هر گونه تغییر در درصد تعیین شده برای ارجاع یا ثبت
              معرف برای کاربران تاثیری در سهم معرف در کارمزد معاملات انجام شده
              پیش از آن تاریخ نخواهد داشت.
            </li>
            <li data-v-e8d0da8a="" className="mt-24 li_referral">
              پارسیان بیت این حق را برای خود محفوظ می&zwnj;داند که هر زمان در
              صورت صلاحدید قوانین طرح معرفی دوستان را تغییر دهد
            </li>
          </ul>
        </Box>
      </Container>
    </Box>
  );
}
